// Common Service Functions
import { apiRequest, buildURL } from './commons/CommonService.Functions';

// Models
import { Consumer, NewConsumer } from '../models/Entities/Consumer';

// Base URL
const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'protocols/consumers';

/**
 * Get all consumers
 * @param token - Authorization token
 * @returns Promise with array of consumers
 */
export const GetAllConsumers = async (token: string): Promise<Consumer[]> => {
  return apiRequest<Consumer[]>(
    BaseURL,
    token,
    'GetAllConsumers',
    { method: 'GET' }
  );
};

/**
 * Get consumer by id
 * @param token - Authorization token
 * @param id - Consumer id
 * @returns Promise with consumer data
 */
export const GetConsumerById = async (
  token: string,
  id: string
): Promise<Consumer> => {
  return apiRequest<Consumer>(
    buildURL(BaseURL, id),
    token,
    'GetConsumerById',
    { method: 'GET' }
  );
};

/**
 * Create a new consumer
 * @param token - Authorization token
 * @param consumer - New consumer data
 * @returns Promise with created consumer
 */
export const CreateConsumer = async (
  token: string,
  consumer: NewConsumer
): Promise<Consumer> => {
  return apiRequest<Consumer>(
    BaseURL,
    token,
    'CreateConsumer',
    { 
      method: 'POST',
      body: JSON.stringify(consumer)
    }
  );
};

/**
 * Update an existing consumer
 * @param token - Authorization token
 * @param id - Consumer id
 * @param consumer - Updated consumer data
 * @returns Promise with updated consumer
 */
export const UpdateConsumer = async (
  token: string,
  id: string,
  consumer: NewConsumer
): Promise<Consumer> => {
  return apiRequest<Consumer>(
    buildURL(BaseURL, id),
    token,
    'UpdateConsumer',
    { 
      method: 'PUT',
      body: JSON.stringify(consumer)
    }
  );
};

/**
 * Delete a consumer
 * @param token - Authorization token
 * @param id - Consumer id
 * @returns Promise with deleted consumer id
 */
export const DeleteConsumer = async (
  token: string,
  id: string
): Promise<string> => {
  return apiRequest<string>(
    buildURL(BaseURL, id),
    token,
    'DeleteConsumer',
    { method: 'DELETE' }
  );
};
